// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"df","title":"ef","nav":"ff","flexCell":"gf","facetLink":"hf"};